"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqlEditorLogger = exports.sqlEditorLog = void 0;
const ui_1 = require("@grafana/ui");
let sqlEditorLogger = { logger: () => { } };
exports.sqlEditorLogger = sqlEditorLogger;
let sqlEditorLog = () => { };
exports.sqlEditorLog = sqlEditorLog;
if (ui_1.attachDebugger && ui_1.createLogger) {
    exports.sqlEditorLogger = sqlEditorLogger = (0, ui_1.createLogger)('SQLEditor');
    exports.sqlEditorLog = sqlEditorLog = sqlEditorLogger.logger;
    (0, ui_1.attachDebugger)('sqleditor', undefined, sqlEditorLogger);
}
//# sourceMappingURL=debugger.js.map